import {GetOrganizationsWithCustomersRoutine} from '~modules/Companies/redux-routines';

export const initialState = {
  data: [],
  error: null,
  isLoading: false,
};

export const organizationsWithCustomersReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case GetOrganizationsWithCustomersRoutine.REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GetOrganizationsWithCustomersRoutine.SUCCESS: {
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };
    }
    case GetOrganizationsWithCustomersRoutine.FAILURE: {
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    }
    default:
      return state;
  }
};
